import {
    RECEIVE_TAX_CONSULTATION_TOPICS,
    REMOVE_TAX_CONSULTATION_TOPIC,
    REQUEST_TAX_CONSULTATION_TOPICS,
} from '../actions'
import { removeItemsById, updateOrAddItemsById } from '../helpers'

const initialState = {
    isFetching: null,
    fetchSuccessful: null,
    items: [],
}

export default (state = initialState, actions) => {
    const { type, data } = actions

    switch (type) {
        case REQUEST_TAX_CONSULTATION_TOPICS:
            return { ...state, isFetching: true }

        case RECEIVE_TAX_CONSULTATION_TOPICS: {
            const items = updateOrAddItemsById({ currentItems: state.items, receivedItems: data.items })
            return { ...state, ...data, items, isFetching: false }
        }

        case REMOVE_TAX_CONSULTATION_TOPIC: {
            const items = removeItemsById({ currentItems: state.items, id: data.id })

            return { ...state, ...data, items, isFetching: false }
        }

        default:
            return state
    }
}
